// 提现金额选项公共配置
// 后续如需增减或调整顺序，仅改这里即可

export const DEFAULT_WITHDRAW_AMOUNT_OPTIONS: number[] = [
  110, 300, 500, 1000, 2000, 5000, 10000, 20000, 35000,
];

export interface WithdrawAmountConfig {
  options: number[];
}

export const withdrawAmountConfig: WithdrawAmountConfig = {
  options: DEFAULT_WITHDRAW_AMOUNT_OPTIONS,
};

export default withdrawAmountConfig;
